const stats = [
  { value: '每日更新', label: '热门连载' },
  { value: '1000+', label: '收录作品' },
  { value: '安全阅读', label: '无广告干扰' },
];

export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20dramatic%20artistic%20illustration%20featuring%20a%20young%20character%20in%20Korean%20manhwa%20webtoon%20style%2C%20dynamic%20vertical%20composition%20with%20vibrant%20warm%20coral%20and%20amber%20tones%2C%20moody%20atmospheric%20lighting%20with%20soft%20bokeh%20effects%2C%20digital%20art%20aesthetic%20with%20painterly%20textures%2C%20modern%20Korean%20comic%20illustration%2C%20gradient%20background%20transitioning%20from%20warm%20rose%20to%20creamy%20beige%2C%20highly%20detailed%20character%20design%20with%20flowing%20hair%20and%20expressive%20eyes%2C%20editorial%20quality%20with%20cinematic%20composition&width=1600&height=900&seq=hero-bg-kr-comics&orientation=landscape"
          alt="韩国漫画 - 精选好看的韩国漫画推荐"
          title="韩国漫画 | 好看的韩国漫画推荐 韩国漫画排行榜"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/55"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-10 md:gap-14">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/15 backdrop-blur-sm mb-6">
              <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></span>
              <span className="text-xs md:text-sm font-medium text-white">热门韩国漫画每日更新</span>
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading leading-tight text-white">
              韩国漫画 · 发现你的下一部必看佳作
            </h1>

            <p className="text-white/85 text-base md:text-lg mt-5 font-medium">
              好看的韩国漫画推荐 · 韩国漫画排行榜 · 免费韩国漫画在线看
            </p>

            <p className="text-white/80 text-sm md:text-base mt-5 leading-relaxed max-w-xl mx-auto lg:mx-0">
              专注精选好看的韩国漫画推荐与排行榜，收录海量免费韩国漫画大全。
              每日追踪人气高分必看作品，为你打造纯粹的韩国漫画在线阅读体验，
              无论你是资深漫画迷还是刚刚入门，都能在这里找到心仪的下一部韩国漫画。
            </p>

            <p className="text-white/70 text-sm md:text-base mt-4 leading-relaxed max-w-xl mx-auto lg:mx-0">
              当前站内聚焦浪漫恋爱、奇幻冒险与热血动作三大核心题材，热门连载保持每日同步更新，
              高分必看榜单每周刷新，助你第一时间锁定口碑佳作与话题新番。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mt-7">
              {stats.map((s) => (
                <div key={s.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-heading text-accent-400">{s.value}</div>
                  <div className="text-xs md:text-sm text-white/65 mt-1">{s.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-8">
              <a
                href="#ranking"
                onClick={(e) => { e.preventDefault(); document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="inline-flex items-center gap-2 px-7 py-3 rounded-md bg-primary-500 text-white font-medium text-sm whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
              >
                <i className="ri-fire-line text-lg"></i>
                查看人气排行
              </a>
              <a
                href="#cards"
                onClick={(e) => { e.preventDefault(); document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="inline-flex items-center gap-2 px-7 py-3 rounded-md border border-white/30 text-white font-medium text-sm whitespace-nowrap cursor-pointer hover:bg-white/10 transition-colors"
              >
                <i className="ri-book-open-line text-lg"></i>
                探索精选推荐
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-[280px] h-[380px] sm:w-[320px] sm:h-[440px] md:w-[360px] md:h-[480px] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20stunning%20Korean%20manhwa%20style%20character%20portrait%2C%20romantic%20fantasy%20genre%2C%20beautiful%20female%20protagonist%20with%20long%20flowing%20dark%20hair%20and%20shimmering%20eyes%2C%20wearing%20an%20elegant%20blend%20of%20modern%20and%20historical%20Korean%20fashion%20with%20delicate%20embroidery%2C%20soft%20cherry%20blossom%20petals%20floating%20in%20the%20air%2C%20warm%20golden%20hour%20lighting%20casting%20gentle%20highlights%2C%20dreamy%20atmospheric%20background%20with%20soft%20out%20of%20focus%20blossoms%2C%20vertical%20webtoon%20composition%2C%20vibrant%20yet%20soft%20color%20palette%20with%20rose%20and%20amber%20tones%2C%20highly%20detailed%20digital%20illustration%20with%20painterly%20textures&width=720&height=960&seq=hero-visual-kr-manhwa&orientation=portrait"
                alt="韩国漫画 - 精选好看的韩国漫画推荐 高分必看作品"
                title="好看的韩国漫画推荐 | 韩国漫画排行榜"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}